var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none",
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1AC1B1",
    d: "M10.518.35v3.248h3.35L10.518.35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#628BF5",
    d: "M8.662 11.4c0-2.978 2.499-5.4 5.57-5.4V4.8h-4.95V0H0v18h14.231v-1.2c-3.07 0-5.569-2.422-5.569-5.4zM2.475 3.6h4.95v1.2h-4.95V3.6zm4.95 10.8h-4.95v-1.2h4.95v1.2zm0-2.4h-4.95v-1.2h4.95V12zm0-2.4h-4.95V8.4h4.95v1.2zm.619-2.4H2.475V6h5.569v1.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.231,
    cy: 11.44,
    r: 4.777,
    fill: "#628BF5",
    stroke: "#fff",
    strokeWidth: 0.477
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.318,
    d: "M16.44 9.316l.883.803-3.819 4.195-2.522-2.439.83-.857 1.638 1.585 2.99-3.287z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.abcc1a4dc30fb3de893640ce7e28bef8.svg";
export { ForwardRef as ReactComponent };